import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  InputGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  Button
} from "reactstrap";
import { StoreService } from "../../services/storeService";
import { Redirect } from "react-router";
import { CompanyService } from "../../services/companyService";
import { ChannelService } from "../../services/channelService";
import { ZoneService } from "../../services/zoneService";
import { BrandService } from "../../services/brandService";
import { PlaylistService } from "../../services/playlistService";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {reloadPlaylist} from "../../redux/actions";
import {Link} from "react-router-dom";

let storeService = new StoreService();
let companyService = new CompanyService();
let channelService = new ChannelService();
let brandService = new BrandService();
let zoneService = new ZoneService();
let playlistService = new PlaylistService();

class EditStoreConnector extends Component {
  constructor(props) {
    super(props);
    let creating;
    if (this.props.match.params.hasOwnProperty("id")) creating = false;
    else creating = true;
    this.state = {
      name: "",
      manager: "",
      email: "",
      telephone: "",
      companyId: "",
      brandId: "",
      zoneId: "",
      playlistMusicId: "",
      playlistSpotId: "",
      loading: !creating,
      creating: creating,
      //playlists: [],
      success: false
    };
    companyService.reload();
    channelService.reload();
    brandService.reload();
    zoneService.reload();
    playlistService.reload();
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleBrand = this.handleBrand.bind(this);
    this.handlePlaylistMusic = this.handlePlaylistMusic.bind(this);
    this.handlePlaylistSpot = this.handlePlaylistSpot.bind(this);

    if (!creating) this.loadData();
  }
  handleChange(event) {
    this.setState({ [event.target.id]: event.target.value });
  }
  handleBrand(event) {
    let brand = this.props.brands.find(x => event.target.value === x.id);
    this.setState({
      brandId: brand ? brand.id : "",
      channelId: brand ? brand.channelId : "",
      zoneId: ""
    });
  }
  handlePlaylistMusic(event) {
    this.setState({
      playlistMusicId: event.target.value ? event.target.value : ""
    });
  }
  handlePlaylistSpot(event) {
    this.setState({
      playlistSpotId: event.target.value ? event.target.value : ""
    });
  }
  handleSubmit(event) {
    this.sendMessage();
    event.preventDefault();
    let self = this;
    const {
      name,
      manager,
      email,
      telephone,
      companyId,
      brandId,
      zoneId,
      playlistMusicId,
      playlistSpotId
    } = this.state;
    let req = {
      name: name,
      manager: manager,
      email: email.toLowerCase(),
      telephone: telephone,
      companyId: companyId,
      brandId: brandId,

      playlistMusicId: playlistMusicId,
      playlistSpotId: playlistSpotId
    };
    if(zoneId){
      req.zoneId = zoneId;
    }
    storeService
      .createOrEdit(req, this.props.match.params.id)
      .then(function(data) {
        if (!data.hasOwnProperty("error")) {
          self.setState({
            success: true
          });
          self.context.getNotificationSystem().addNotification({
            message:
              "Se ha " +
              (self.state.creating ? "creado" : "editado") +
              " exitosamente un Tienda.",
            level: "success"
          });
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  }
  loadData() {
    let self = this;
    storeService
      .readByID(this.props.match.params.id)
      .then(function(data) {
        if (!data.hasOwnProperty("error")) {
          data.loading = false;
          self.setState(data);
        }
      })
      .catch(function(error) {
        console.log(error);
      });
    playlistService
      .read()
      .then(function(data) {
        if (!data.hasOwnProperty("error")) {
          self.props.reloadPlaylist(data);
        }
        if (self.mounted)
          self.setState({
            loading: false
          });
      })
      .catch(function(error) {
        console.log(error);
      });
  }
  sendMessage(){
    this.context.getNotificationSystem().addNotification({
      message:
        "Guardando datos, por favor espere.",
      title: this.state.creating
        ? "Creación"
        : "Edición",
      level: "info"
    });
  }

  render() {
    const {
      creating,
      name,
      telephone,
      manager,
      email,
      loading,
      success,
      companyId,
      brandId,
      zoneId,
      playlistMusicId,
      playlistSpotId
    } = this.state;

    let zones = this.props.zones.filter(x => x.brandId === brandId);
    if (success) return <Redirect to="/stores" push={true} />;
    return (
      <div className="animated fadeIn">
        <Row>
          <Col xs="12" sm="12" lg="12">
            <Card>
              <CardHeader>
                <Row>
                  <Col sm="5">
                    <CardTitle className="mb-0">
                      {creating ? "Agregando Tienda" : "Editando Tienda"}
                    </CardTitle>
                    <div className="small text-muted">{name}</div>
                  </Col>
                  <Col sm="7" className="d-sm-inline-block" />
                </Row>
              </CardHeader>
              <CardBody>
                <form onSubmit={this.handleSubmit}>
                  <Row>
                    <Col>
                      <InputGroup className="mb-3">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>Nombre</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          required
                          type="text"
                          disabled={loading}
                          id="name"
                          value={name}
                          onChange={this.handleChange}
                        />
                      </InputGroup>
                      <InputGroup className="mb-3">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>Encargado</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          required
                          type="text"
                          disabled={loading}
                          id="manager"
                          value={manager}
                          onChange={this.handleChange}
                        />
                      </InputGroup>
                      <InputGroup className="mb-3">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>Email</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          required
                          type="text"
                          disabled={loading}
                          id="email"
                          value={email}
                          onChange={this.handleChange}
                        />
                      </InputGroup>
                      <InputGroup className="mb-3">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>Telefono</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="text"
                          disabled={loading}
                          id="telephone"
                          value={telephone}
                          onChange={this.handleChange}
                        />
                      </InputGroup>
                      <InputGroup className="mb-3">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>Compañia</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          required
                          type="select"
                          id="companyId"
                          value={companyId}
                          onChange={this.handleChange}
                        >
                          <option value="">Selecciona una Compañia</option>
                          {this.props.companies.map((e, i) => {
                            return (
                              <option key={i} value={e.id}>
                                {e.name}
                              </option>
                            );
                          })}
                        </Input>
                      </InputGroup>
                      <InputGroup className="mb-3">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>Marca</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          required
                          type="select"
                          id="brandId"
                          value={brandId}
                          onChange={this.handleBrand}
                        >
                          <option value="">Selecciona una Marca</option>
                          {this.props.brands
                            .filter(x => x.companyId === companyId)
                            .map((e, i) => {
                              return (
                                <option key={i} value={e.id}>
                                  {e.name}
                                </option>
                              );
                            })}
                        </Input>
                      </InputGroup>
                      <InputGroup className="mb-3">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>Playlist música</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="select"
                          id="playlistMusicId"
                          value={playlistMusicId}
                          onChange={this.handlePlaylistMusic}
                        >
                          <option value="">Selecciona una Playlist</option>
                          {this.props.playlists
                            .filter(x => x.type === 'music')
                            .map((e, i) => {
                              return (
                                <option key={i} value={e.id}>
                                  {e.name}
                                </option>
                              );
                            })}
                        </Input>
                      </InputGroup>
                      <InputGroup className="mb-3">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>Playlist publicidad</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="select"
                          id="playlistSpotId"
                          value={playlistSpotId}
                          onChange={this.handlePlaylistSpot}
                        >
                          <option value="">Selecciona una Playlist</option>
                          {this.props.playlists
                            .filter(x => x.type === 'spot')
                            .map((e, i) => {
                              return (
                                <option key={i} value={e.id}>
                                  {e.name}
                                </option>
                              );
                            })}
                        </Input>
                      </InputGroup>
                      {zones.length !== 0 && (
                        <InputGroup className="mb-3">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>Zona</InputGroupText>
                          </InputGroupAddon>
                          <Input
                            type="select"
                            id="zoneId"
                            value={zoneId}
                            onChange={this.handleChange}
                          >
                            <option value="">Selecciona una Zona</option>
                            {zones.map((e, i) => {
                              return (
                                <option key={i} value={e.id}>
                                  {e.name}
                                </option>
                              );
                            })}
                          </Input>
                        </InputGroup>
                      )}
                      <div className="float-right">
                        {creating ? <Link
                            to={"/stores/"}
                            className="btn btn-danger"
                          >
                            Cancelar
                          </Link>
                          : <Link
                            to={"/stores/view/"+this.props.match.params.id}
                            className="btn btn-danger"
                          >
                            Cancelar
                          </Link>}

                        <span> </span>
                        <Button color="success">
                          {creating ? "Agregar" : "Guardar"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

EditStoreConnector.contextTypes = {
  getNotificationSystem: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  return {
    companies: state.companies,
    user: state.user,
    channels: state.channels,
    brands: state.brands,
    zones: state.zones,
    playlists: state.playlists
  };
};

const mapDispatchToProps = dispatch => {
  return {
    reloadPlaylist: playlists => dispatch(reloadPlaylist(playlists))
  };
};

const EditStore = connect(
  mapStateToProps,
  mapDispatchToProps
)(EditStoreConnector);

export default EditStore;
